/*=============================================== DemoPaginator ===============================================*/

import {
    Paginator,
    Card,
    Text,
    Grid,
    uuid,
    generateNumbers,
    usePaginatedData,
} from "tsx-library-julseb"

import { WrapperPagination } from "components"

const DemoPaginator = () => {
    const arr: string[] = generateNumbers(1, 201).map(n => `Hello ${n}`)
    const { getNumberOfPages, getPaginatedData } = usePaginatedData(arr)

    return (
        <WrapperPagination title="Demo Paginator">
            {getPaginatedData() && (
                <Grid col={4} gap="s">
                    {getPaginatedData().map(text => (
                        <Card border={{ width: 1 }} key={uuid()}>
                            <Text>{text}</Text>
                        </Card>
                    ))}
                </Grid>
            )}

            {getNumberOfPages() && (
                <Paginator
                    totalPages={getNumberOfPages()}
                    icons={{ prev: "arrow-left", next: "arrow-right" }}
                />
            )}
        </WrapperPagination>
    )
}

export default DemoPaginator
